import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { FeeModel } from '../../../model/feeModel';
import { environment } from '../../../../environments/environment';
import { WorkflowModel } from '../../../model/workflowModel';
import { StartPaymentRequestModel } from '../../../model/startPaymentRequestModel';
import { MessageModel } from '../../../model/models';
import { Subscription } from 'rxjs';
import { SubmitIndividualCorporationStatusResponseModel } from '../../../model/submitIndividualCorporationStatusResponseModel';
import { SubmitQuestionnaireAnswersResponseModel } from '../../../model/submitQuestionnaireAnswersResponseModel';
import { SelectInactiveOfficesToRenewResponseModel } from '../../../model/selectInactiveOfficesToRenewResponseModel';
import { QuestionnaireQuestionModel } from '../../../model/questionnaireQuestionModel';
import { StorageService } from '../../../shared/security/StorageService';
import { ChangeEmployerService } from '../../../broker/change-employer/change-employer.service';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { IndividualRenewalService } from '../../individual-renewal/individual-renewal.service';
import { EntityRenewalService } from '../entity-renewal.service';
import { PaymentService } from '../../../shared/payment/payment.service';
import { Router } from '@angular/router';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { StartPaymentResponseModel } from '../../../model/startPaymentResponseModel';

@Component({
  selector: 'app-renewal-pay',
  templateUrl: './renewal-pay.component.html',
  styleUrls: ['./renewal-pay.component.css']
})
export class RenewalPayComponent implements OnInit, OnDestroy {
 

  startFunction: StartFunctionResponseModel = {};
  products: Array<FeeModel> = [];
  total: number = 0;

  receiptPageReturnUrl = environment.renewalReceiptPageReturnUrl;
  workflow: WorkflowModel = new WorkflowModel();
  startPaymentRequest: StartPaymentRequestModel = new StartPaymentRequestModel();

  userMessages: Array<MessageModel> = [];

  notifyIndividualCorporationStatusResponseSubscription = new Subscription();
  notifySubmitQuestionnaireAnswersSubscription: Subscription = new Subscription();
  notifySubmitEntityQuestionnaireAnswersSubscription: Subscription = new Subscription();
  notifySelectInactiveOfficesToRenewSubscription: Subscription = new Subscription();
  notifyEntityQuestionListSubscription: Subscription = new Subscription();
  notifyIndividualQuestionListSubscription: Subscription = new Subscription();


  individualCorporationStatusResponse: SubmitIndividualCorporationStatusResponseModel = new SubmitIndividualCorporationStatusResponseModel();
  submitIndividualQuestionnaireAnswersResponseModel: SubmitQuestionnaireAnswersResponseModel = new SubmitQuestionnaireAnswersResponseModel();
  submitEntityQuestionnaireAnswersResponseModel: SubmitQuestionnaireAnswersResponseModel = new SubmitQuestionnaireAnswersResponseModel();
  selectInactiveOfficesToRenewResponseModel: SelectInactiveOfficesToRenewResponseModel = new SelectInactiveOfficesToRenewResponseModel();
  entityRenewalQuestions: Array<QuestionnaireQuestionModel> = [];
  individualRenewalQuestions: Array<QuestionnaireQuestionModel> = [];

  constructor(private storage: StorageService,
    private changeEmployerService: ChangeEmployerService,
    private currentPageWatcher: CurrentPageWatcherService,
    private individualRenewalService: IndividualRenewalService,
    private entityRenewalService: EntityRenewalService,
    private paymentService: PaymentService,
    private router: Router,
    private startFunctionService : StartFunctionService) {

    this.notifyIndividualCorporationStatusResponseSubscription = this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().subscribe(
      (data: SubmitIndividualCorporationStatusResponseModel) => {
        this.individualCorporationStatusResponse = data;
      }
    );

    this.notifySubmitQuestionnaireAnswersSubscription = this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().subscribe(submitQuestionnaireAnswersResp => {
      this.submitIndividualQuestionnaireAnswersResponseModel = submitQuestionnaireAnswersResp;

    });

    this.notifySubmitEntityQuestionnaireAnswersSubscription = this.entityRenewalService.getNotifySubmitQuestionnaireAnswersResponseModel().subscribe(submitQuestionnaireAnswersResp => {
      this.submitEntityQuestionnaireAnswersResponseModel = submitQuestionnaireAnswersResp;

    });

    this.notifySelectInactiveOfficesToRenewSubscription = this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().subscribe(
      selectInactiveOfficesData => {
        this.selectInactiveOfficesToRenewResponseModel = selectInactiveOfficesData;

      });

      this.notifyEntityQuestionListSubscription = this.entityRenewalService.getNotifyQuestionList().subscribe(questionListData => {
        this.entityRenewalQuestions = questionListData;

        console.log("this.entityRenewalQuestions ",this.entityRenewalQuestions);
      });

      this.notifyIndividualQuestionListSubscription = this.individualRenewalService.getNotifyIndividualQuestionList().subscribe(questionListData => {
        this.individualRenewalQuestions = questionListData;
      });
  }

  ngOnInit() {

    //init data from localstorage if receipt page is returned from scs (no emitter)
    if (this.entityRenewalQuestions == null || this.entityRenewalQuestions.length == 0) {
      this.entityRenewalQuestions = this.entityRenewalService.getQuestionListData();
    }
    if (this.individualCorporationStatusResponse == null) {
      this.individualCorporationStatusResponse = this.individualRenewalService.getIndividualCorporationStatusData();
    }
    if (this.individualRenewalQuestions == null || this.individualRenewalQuestions.length == 0) {
      this.individualRenewalQuestions = this.individualRenewalService.getIndividualRenewalQuestionsData();
    }
    if (this.selectInactiveOfficesToRenewResponseModel == null) {
      this.selectInactiveOfficesToRenewResponseModel = this.entityRenewalService.getSelectInactiveOfficesToRenewResponseData();
    }
    if (this.submitEntityQuestionnaireAnswersResponseModel == null) {
      this.submitEntityQuestionnaireAnswersResponseModel = this.entityRenewalService.getSubmitQuestionnaireAnswersResponseData();
    }
    if (this.submitIndividualQuestionnaireAnswersResponseModel == null) {
      this.submitIndividualQuestionnaireAnswersResponseModel = this.individualRenewalService.getSubmitIndividualQuestionnaireAnswersData();
    }

    this.startFunction = this.storage.getStartFunctionData();

    if (this.entityRenewalService.renewalWorkflowModel == undefined || this.entityRenewalService.renewalWorkflowModel == null) {
      this.workflow = this.startFunction.Workflow;
    }
    else {
      this.workflow = this.entityRenewalService.renewalWorkflowModel;
    }

    //save startFunction with updated workflow in localstorage
    this.startFunction.Workflow.CurrentStepIndex = (this.workflow.CurrentStepIndex ? this.workflow.CurrentStepIndex : null);
    this.startFunction.Workflow.WorkflowID = (this.workflow.WorkflowID ? this.workflow.WorkflowID : null);
    this.startFunction.Workflow.WorkflowDisplayName = (this.workflow.WorkflowDisplayName ? this.workflow.WorkflowDisplayName : null);
    this.startFunction.Workflow.Fees = (this.workflow.Fees ? this.workflow.Fees : null);

    this.storage.setStartFunctionData(this.startFunction);

    // fill products list from workflow fees
    this.workflow.Fees.forEach(fee => {
      let product = fee;
      product.Quantity = this.workflow.Fees.filter(e => e.FeeType == fee.FeeType).length;
      this.products.push(product);
    });
    this.products = this.workflow.Fees.map(e => e["FeeType"])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter(e => this.workflow.Fees[e]).map(e => this.workflow.Fees[e]);

    this.products.forEach(pr => {
      this.total += pr.Amount * pr.Quantity;

    });

    this.startPaymentRequest.workflowID = this.workflow.WorkflowID;
    this.startPaymentRequest.currentStepIndex = this.workflow.CurrentStepIndex;
    this.startPaymentRequest.scsReturnToApplicationUrl = this.receiptPageReturnUrl;
  }

  continue() {

    this.paymentService.submitPaymentRequest(this.startPaymentRequest).subscribe((response: StartPaymentResponseModel) => {

      console.log("submitPayment resonse : ", response);
      let startPaymentResponse: StartPaymentResponseModel = response;

      response.UserMessages.forEach(msg => {
        this.userMessages.push(msg);
      })
      this.currentPageWatcher.sendUserMessages(this.userMessages);
      if (response.Summary == 0) {

        // this.startFunctionService.getNotifyStepInProgress().emit(true);
        this.entityRenewalService.storeQuestionListData(this.entityRenewalQuestions);
        this.entityRenewalService.storeSelectInactiveOfficesToRenewResponseData(this.selectInactiveOfficesToRenewResponseModel);
        this.entityRenewalService.storeSubmitQuestionnaireAnswersResponseData(this.submitEntityQuestionnaireAnswersResponseModel);
        this.individualRenewalService.storeIndividualCorporationStatusData(this.individualCorporationStatusResponse);
        this.individualRenewalService.storeIndividualRenewalQuestionsData(this.individualRenewalQuestions);
        this.individualRenewalService.storeSubmitIndividualQuestionnaireAnswersData(this.submitIndividualQuestionnaireAnswersResponseModel);

       window.location.assign(startPaymentResponse.RedirectUrl);
        this.userMessages = [];
      }
      if (response.Summary == 1) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        this.userMessages = [];

      }

      if (response.Summary == 2) {
        this.router.navigate(["/home"]);
        this.userMessages = [];
      }

    });
  }

  goBack(){
    this.router.navigate(["/reviewEntityRenewal"]).then(()=>{
      this.startFunctionService.getNotifyStepInProgress().emit(false);
      this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
        this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitIndividualQuestionnaireAnswersResponseModel);
        this.entityRenewalService.getNotifySubmitQuestionnaireAnswersResponseModel().emit(this.submitEntityQuestionnaireAnswersResponseModel);
        this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(this.selectInactiveOfficesToRenewResponseModel);
        this.entityRenewalService.getNotifyQuestionList().emit(this.entityRenewalQuestions);
        this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);

    })
  }

  //back browser button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.goBack();
  }
  ngOnDestroy(): void {
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
  }
}


// WEBPACK FOOTER //
// ./src/app/renewal/entity-renewal/renewal-pay/renewal-pay.component.ts